import { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';
import { rolesApp } from 'src/utils/rolesConstants';
import { validateRoles } from 'src/utils/validateRoles';

interface GuestProps {
  children: ReactNode;
}

const Guest: FC<GuestProps> = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  const allowedRoles = [rolesApp.SUPERADMIN, rolesApp.PRODUCTOR];
  const userRoles = user?.proRoles || [];
  const isUserAllowed = validateRoles(userRoles, allowedRoles);

  if (isAuthenticated) {
    if (isUserAllowed) {
      return <Navigate to="/dashboard/management/home" />;
    }
    return <Navigate to="/dashboard/management/events/list" />;
  }

  return <>{children}</>;
};

Guest.propTypes = {
  children: PropTypes.node as PropTypes.Validator<ReactNode>
};

export default Guest;
